import { render, staticRenderFns } from "./shippingLable.vue?vue&type=template&id=7c0fb38e&scoped=true"
import script from "./shippingLable.vue?vue&type=script&lang=js"
export * from "./shippingLable.vue?vue&type=script&lang=js"
import style0 from "./shippingLable.vue?vue&type=style&index=0&id=7c0fb38e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0fb38e",
  null
  
)

export default component.exports